import React from 'react';
import { makeStyles } from '@mui/styles';
import { AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ParamTable from '../ParamTable';
import { CodeHighlighter } from '../index';
import { AdminProgressBar } from '../../../../components';

const useStyles = makeStyles((theme) => ({
  pre: {
    whiteSpace: 'pre-wrap',
  },
  childAccordion: {
    display: 'block',
  },
  headingPost: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: theme.palette.success.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const DietsAll = () => {
  const classes = useStyles();
  return (
    <AccordionDetails className={classes.childAccordion}>
      <Typography>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          justifyContent={'space-between'}
        >
          {/*
                       <Grid item xs={2}><h3>Example Request</h3></Grid>
                      <Grid item xs={10}>
                      <pre className={classes.pre}>
                      <code>
                    </code>
                      </pre>
                      </Grid>
                      */}
          <Grid
            item
            xs={2}
          >
            <h3>Example Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
	"data": [{
		"id": 141,
		"name": "NoRedMeat",
		"code": "NRM",
		"quality": 1,
		"longName": "NoRedMeatquality1(1outof10)",
		"description": "Thisdietarypatterntypicallyincludeshighlyprocessedmealsandsnacks,friedfoods,packaged/conveniencefoods,sweetenedbeverages,sweets,andfastfood.",
		"hei": 22,
		"calories": 1991.569,
		"adjustedCalories": "",
		"fingerprintPhotoUrl": "https://dqpn.imgix.net/assets/diet-images/141_NRM/1/fingerprint_photo_XwwtipfMWbRDYNmEFaOLVqsonHlUpk.png?w=960&auto=format,compression&txtalign=bottom%2Cright&txtclr=c1cdbd&txt=%C2%A9%202022%20Diet%20ID%20Inc&txtsize=36&txtfont=Arial%2CBoldMT&txtpad=15&txtalign=center",
		"foodGroupValues": {
			"FRU0100": 0.0,
			"FRU0200": 0.0,
			"FRU0300": 0.0,
			"FRU0400": 0.0,
			"FRU0500": 0.0,
			"FRU0600": 0.0,
			"FRU0700": 0.0,
			"VEG0100": 0.0,
			"VEG0200": 0.0,
			"VEG0300": 0.0,
			"VEG0400": 0.1946666666666667,
			"VEG0800": 0.357,
			"VEG0450": 0.0,
			"VEG0700": 0.0,
			"VEG0600": 0.082,
			"VEG0900": 0.0,
			"VEG0500": 0.0,
			"FMC0100": 0.0,
			"GRW0100": 0.0,
			"GRS0100": 0.0,
			"GRR0100": 0.3126666666666666,
			"GRW0200": 0.0,
			"GRS0200": 0.0,
			"GRR0200": 2.279333333333333,
			"GRW0300": 0.0,
			"GRS0300": 0.0,
			"GRR0300": 0.8346666666666667,
			"GRW0400": 0.0,
			"GRS0400": 0.0,
			"GRR0400": 0.0,
			"GRW0500": 0.0,
			"GRS0500": 0.0,
			"GRR0500": 0.381,
			"GRW0600": 0.0,
			"GRS0600": 0.0,
			"GRR0600": 0.0,
			"GRW0700": 0.0,
			"GRS0700": 0.0,
			"GRR0700": 0.0,
			"GRW0800": 0.0,
			"GRS0800": 0.0,
			"GRR0800": 2.432666666666667,
			"GRW1000": 0.0,
			"GRS1000": 0.0,
			"GRR1000": 0.0,
			"GRW0900": 0.0,
			"GRS0900": 0.0,
			"GRR0900": 0.0,
			"GRW1100": 0.0,
			"GRW1200": 0.0,
			"GRR1300": 0.0,
			"MRF0100": 0.0,
			"MRL0100": 0.0,
			"MRF0200": 0.0,
			"MRL0200": 0.0,
			"MRF0300": 0.0,
			"MRL0300": 0.0,
			"MRF0400": 0.0,
			"MRL0400": 0.0,
			"MCF0200": 0.0,
			"MCL0200": 0.0,
			"MRF0500": 0.0,
			"MPF0100": 0.3293333333333333,
			"MPL0100": 0.3173333333333333,
			"MPF0200": 1.27,
			"MFF0100": 0.0,
			"MFL0100": 0.0,
			"MFF0200": 0.6703333333333333,
			"MSL0100": 0.0,
			"MSF0100": 0.0,
			"MCF0100": 0.6703333333333333,
			"MCL0100": 0.0,
			"MOF0100": 0.0,
			"MOF0200": 0.0,
			"FMC0200": 0.0,
			"MOF0300": 0.0,
			"MOF0400": 0.0,
			"MOF0500": 0.0,
			"MOF0600": 0.0,
			"MOF0700": 0.0,
			"DMF0100": 0.0,
			"DMR0100": 0.0,
			"DML0100": 0.0,
			"DMN0100": 0.006333333333333333,
			"DMF0200": 0.0,
			"DMR0200": 0.0,
			"DML0200": 0.0,
			"DML0300": 0.0,
			"DML0400": 0.0,
			"SWT0600": 0.0,
			"MSC1100": 0.0,
			"DCF0100": 0.3916666666666667,
			"DCR0100": 0.1333333333333333,
			"DCL0100": 0.0,
			"DCN0100": 0.0,
			"DYF0100": 0.0,
			"DYR0100": 0.0,
			"DYL0100": 0.0,
			"DYF0200": 0.0,
			"DYR0200": 0.0,
			"DYL0200": 0.0,
			"DYN0100": 0.0,
			"DOT0100": 0.0,
			"DOT0200": 0.2913333333333333,
			"DOT0300": 0.0,
			"DOT0400": 0.0,
			"FCF0100": 0.2423333333333333,
			"FCR0100": 0.0,
			"FCL0100": 0.0,
			"FCN0100": 2.666666666666667,
			"DOT0500": 0.0,
			"DOT0600": 0.0,
			"DOT0700": 0.0,
			"DOT0800": 0.0,
			"FMF0100": 0.0,
			"FMR0100": 0.0,
			"FOF0100": 0.904,
			"FSF0100": 0.1816666666666667,
			"FAF0100": 1.333333333333333,
			"FAR0100": 0.0,
			"FDF0100": 0.1166666666666667,
			"FDR0100": 0.4443333333333333,
			"SWT0400": 3.555333333333333,
			"MSC1200": 0.0,
			"SWT0500": 0.1516666666666667,
			"SWT0700": 0.0,
			"SWT0800": 0.0,
			"SWT0100": 0.1333333333333333,
			"SWT0200": 0.7236666666666666,
			"SWT0300": 0.0,
			"BVS0400": 2.5,
			"BVA0400": 0.5,
			"BVU0300": 0.0,
			"BVS0300": 0.0,
			"BVA0300": 0.0,
			"BVS0500": 0.0,
			"BVA0500": 0.0,
			"BVU0400": 0.0,
			"BVS0100": 0.0,
			"BVA0100": 0.0,
			"BVU0100": 0.6516666666666667,
			"BVS0200": 0.0,
			"BVA0200": 0.0,
			"BVU0200": 0.0,
			"BVS0600": 0.0,
			"BVA0600": 0.0,
			"BVU0500": 0.0,
			"BVS0700": 0.0,
			"BVA0700": 0.0,
			"BVU0600": 0.0,
			"BVO0100": 0.0,
			"BVO0200": 0.0,
			"BVE0100": 0.3333333333333333,
			"BVE0400": 0.0,
			"BVE0300": 0.0,
			"BVE0200": 0.0,
			"MSC0100": 0.1666666666666667,
			"MSC0200": 0.0,
			"MSC0300": 0.4749999999999999,
			"MSC0400": 2.708333333333333,
			"MSC0500": 0.0,
			"MSC0600": 0.0,
			"MSC0700": 0.0,
			"MSC0800": 0.0,
			"MSC0900": 0.0,
			"MSC1000": 0.0,
			"GRW1300": 0.0,
			"GRS1300": 0.0
		},
		"foodGroupInfo": {
			"FRU0100": {
				"label": "CitrusJuice",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0200": {
				"label": "FruitJuiceexcludingCitrusJuice",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0300": {
				"label": "CitrusFruit",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0400": {
				"label": "FruitexcludingCitrusFruit",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0500": {
				"label": "Avocados",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0600": {
				"label": "FriedFruits",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0700": {
				"label": "Fruit-basedSavorySnack",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0100": {
				"label": "GreenLeafyVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0200": {
				"label": "Deep-yellowVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0300": {
				"label": "Tomato",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0400": {
				"label": "WhitePotatoes",
				"daily_values": [0.0, 0.584, 0.0],
				"value": 0.1946666666666667
			},
			"VEG0800": {
				"label": "FrenchFries",
				"daily_values": [1.071, 0.0, 0.0],
				"value": 0.357
			},
			"VEG0450": {
				"label": "OtherStarchyVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0700": {
				"label": "Beans",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0600": {
				"label": "OtherVegetables",
				"daily_values": [0.246, 0.0, 0.0],
				"value": 0.082
			},
			"VEG0900": {
				"label": "FriedVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0500": {
				"label": "VegetableJuice",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FMC0100": {
				"label": "VegetableBasedSavorySnack(PotatoChips)",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0100": {
				"label": "Grains,FlourandDryMixes-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0100": {
				"label": "Grains,FlourandDryMixes-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0100": {
				"label": "Grains,FlourandDryMixes-RefinedGrain",
				"daily_values": [0.938, 0.0, 0.0],
				"value": 0.3126666666666666
			},
			"GRW0200": {
				"label": "Loaf-typeBreadandPlainRolls-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0200": {
				"label": "Loaf-typeBreadandPlainRolls-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0200": {
				"label": "Loaf-typeBreadandPlainRolls-RefinedGrain",
				"daily_values": [2.419, 0.0, 4.419],
				"value": 2.279333333333333
			},
			"GRW0300": {
				"label": "QuickandOtherBreads",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0300": {
				"label": "OtherBreads(quickbreads,cornmuffins,tortillas)-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0300": {
				"label": "RefinedSnackBreads",
				"daily_values": [0.0, 2.504, 0.0],
				"value": 0.8346666666666667
			},
			"GRW0400": {
				"label": "Crackers-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0400": {
				"label": "Crackers-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0400": {
				"label": "Crackers-RefinedGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0500": {
				"label": "Pasta-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0500": {
				"label": "Pasta-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0500": {
				"label": "Pasta-RefinedGrain",
				"daily_values": [1.143, 0.0, 0.0],
				"value": 0.381
			},
			"GRW0600": {
				"label": "Ready-to-eatCereal(notpresweetened)-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0600": {
				"label": "Ready-to-eatCereal(notpresweetened)-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0600": {
				"label": "Ready-to-eatCereal(notpresweetened)-RefinedGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0700": {
				"label": "Ready-to-eatCereal(presweetened)-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0700": {
				"label": "Ready-to-eatCereal(presweetened)-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0700": {
				"label": "Ready-to-eatCereal(presweetened)-RefinedGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0800": {
				"label": "WholeGrainCookies,Pies,Pastries,Danish,etc.",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0800": {
				"label": "SomeWholeGrainCookies,Pies,Pastries,Danish,etc.",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0800": {
				"label": "Cookies,Pies,Pastries,Danish,etc.",
				"daily_values": [2.433, 3.128, 1.737],
				"value": 2.432666666666667
			},
			"GRW1000": {
				"label": "WholeGrainSnackBars",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS1000": {
				"label": "SnackBarsSomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR1000": {
				"label": "SnackBars",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0900": {
				"label": "WholeGrainSnackChips",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0900": {
				"label": "SnackChipsSomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0900": {
				"label": "SnackChips",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW1100": {
				"label": "PlainPopcorn",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW1200": {
				"label": "FlavoredPopcorn",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR1300": {
				"label": "BabyFoodGrainMixtures–RefinedGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0100": {
				"label": "Beef",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRL0100": {
				"label": "LeanBeef",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0200": {
				"label": "Veal",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRL0200": {
				"label": "LeanVeal",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0300": {
				"label": "Lamb",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRL0300": {
				"label": "LeanLamb",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0400": {
				"label": "FreshPork",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRL0400": {
				"label": "LeanFreshPork",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MCF0200": {
				"label": "CuredPork",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MCL0200": {
				"label": "LeanCuredPork",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0500": {
				"label": "Game",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MPF0100": {
				"label": "Poultry",
				"daily_values": [0.0, 0.0, 0.988],
				"value": 0.3293333333333333
			},
			"MPL0100": {
				"label": "LeanPoultry",
				"daily_values": [0.952, 0.0, 0.0],
				"value": 0.3173333333333333
			},
			"MPF0200": {
				"label": "FriedChicken",
				"daily_values": [0.0, 3.81, 0.0],
				"value": 1.27
			},
			"MFF0100": {
				"label": "Fish",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MFL0100": {
				"label": "LeanFish",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MFF0200": {
				"label": "FriedFish",
				"daily_values": [0.0, 0.0, 2.011],
				"value": 0.6703333333333333
			},
			"MSL0100": {
				"label": "Shellfish",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSF0100": {
				"label": "FriedShellfish",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MCF0100": {
				"label": "ColdCutsandSausage",
				"daily_values": [0.0, 0.0, 2.011],
				"value": 0.6703333333333333
			},
			"MCL0100": {
				"label": "LeanColdCutsandSausage",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0100": {
				"label": "OrganMeats",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0200": {
				"label": "BabyFoodMeatMixtures",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FMC0200": {
				"label": "MeatBasedSavorySnack(PorkRinds)",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0300": {
				"label": "Eggs",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0400": {
				"label": "EggSubstitute",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0500": {
				"label": "NutsandSeeds",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0600": {
				"label": "NutandSeedButters",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0700": {
				"label": "MeatAlternatives",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DMF0100": {
				"label": "WholeMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DMR0100": {
				"label": "Milk-ReducedFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DML0100": {
				"label": "Milk-LowFatandFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DMN0100": {
				"label": "Milk-Nondairy",
				"daily_values": [0.0, 0.019, 0.0],
				"value": 0.006333333333333333
			},
			"DMF0200": {
				"label": "Ready-to-drinkFlavoredMilk-Whole",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DMR0200": {
				"label": "Ready-to-drinkFlavoredMilk-ReducedFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DML0200": {
				"label": "Ready-to-drinkFlavoredMilk-LowFatandFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DML0300": {
				"label": "SweetenedFlavoredMilkBeveragePowderwithNon-fatDryMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DML0400": {
				"label": "ArtificiallySweetenedFlavoredMilkBeveragePowderwithNon-fatDryMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0600": {
				"label": "SweetenedFlavoredMilkBeveragePowderwithoutNon-fatDryMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC1100": {
				"label": "ArtificiallySweetenedFlavoredMilkBeveragePowderwithoutNon-fatDryMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DCF0100": {
				"label": "Cheese",
				"daily_values": [0.0, 0.8, 0.375],
				"value": 0.3916666666666667
			},
			"DCR0100": {
				"label": "Cheese-ReducedFat",
				"daily_values": [0.0, 0.4, 0.0],
				"value": 0.1333333333333333
			},
			"DCL0100": {
				"label": "Cheese-LowFatandFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DCN0100": {
				"label": "Cheese-Nondairy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYF0100": {
				"label": "Yogurt-SweetenedWholeMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYR0100": {
				"label": "Yogurt-SweetenedLowFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYL0100": {
				"label": "Yogurt-SweetenedFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYF0200": {
				"label": "Yogurt-ArtificiallySweetenedWholeMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYR0200": {
				"label": "Yogurt-ArtificiallySweetenedLowFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYL0200": {
				"label": "Yogurt-ArtificiallySweetenedFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYN0100": {
				"label": "Yogurt-Nondairy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0100": {
				"label": "FrozenDairyDessert",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0200": {
				"label": "FrozenNondairyDessert",
				"daily_values": [0.0, 0.874, 0.0],
				"value": 0.2913333333333333
			},
			"DOT0300": {
				"label": "PuddingandOtherDairyDessert",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0400": {
				"label": "ArtificiallySweetenedPuddingandOtherDairyDessert",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FCF0100": {
				"label": "Cream",
				"daily_values": [0.727, 0.0, 0.0],
				"value": 0.2423333333333333
			},
			"FCR0100": {
				"label": "Cream-ReducedFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FCL0100": {
				"label": "Cream-LowFatandFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FCN0100": {
				"label": "Cream-Nondairy,Soy,rice,grainbased",
				"daily_values": [4.0, 2.0, 2.0],
				"value": 2.666666666666667
			},
			"DOT0500": {
				"label": "Dairy-basedSweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0600": {
				"label": "Dairy-basedArtificiallySweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0700": {
				"label": "InfantFormula",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0800": {
				"label": "InfantFormula-Nondairy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FMF0100": {
				"label": "Margarine",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FMR0100": {
				"label": "Margarine-ReducedFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FOF0100": {
				"label": "VegetableOils",
				"daily_values": [2.712, 0.0, 0.0],
				"value": 0.904
			},
			"FSF0100": {
				"label": "Shortening",
				"daily_values": [0.0, 0.545, 0.0],
				"value": 0.1816666666666667
			},
			"FAF0100": {
				"label": "Butter",
				"daily_values": [0.0, 1.0, 3.0],
				"value": 1.333333333333333
			},
			"FAR0100": {
				"label": "ButterandOtherAnimalFats-ReducedFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FDF0100": {
				"label": "CreamyDressings",
				"daily_values": [0.0, 0.35, 0.0],
				"value": 0.1166666666666667
			},
			"FDR0100": {
				"label": "SaladDressing-ReducedFat/ReducedCalorie/FatFree",
				"daily_values": [1.333, 0.0, 0.0],
				"value": 0.4443333333333333
			},
			"SWT0400": {
				"label": "Sugar",
				"daily_values": [0.25, 5.208, 5.208],
				"value": 3.555333333333333
			},
			"MSC1200": {
				"label": "SugarSubstitute",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0500": {
				"label": "Syrup,Honey,Jam",
				"daily_values": [0.455, 0.0, 0.0],
				"value": 0.1516666666666667
			},
			"SWT0700": {
				"label": "Fudge,caramel,butterscotch,etc.",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0800": {
				"label": "Sauces,Sweet-ReducedFat/ReducedCalorie/FatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0100": {
				"label": "ChocolateCandy",
				"daily_values": [0.0, 0.4, 0.0],
				"value": 0.1333333333333333
			},
			"SWT0200": {
				"label": "Candy",
				"daily_values": [0.709, 0.0, 1.462],
				"value": 0.7236666666666666
			},
			"SWT0300": {
				"label": "Frostingoricing",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0400": {
				"label": "Soda",
				"daily_values": [3.0, 1.5, 3.0],
				"value": 2.5
			},
			"BVA0400": {
				"label": "DietSoda",
				"daily_values": [0.0, 1.5, 0.0],
				"value": 0.5
			},
			"BVU0300": {
				"label": "UnsweetenedSoftDrinks",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0300": {
				"label": "SweetenedFruitDrinks",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0300": {
				"label": "ArtificiallySweetenedFruitDrinks",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0500": {
				"label": "SweetenedTea",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0500": {
				"label": "ArtificiallySweetenedTea",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0400": {
				"label": "UnsweetenedTea",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0100": {
				"label": "SweetenedCoffee",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0100": {
				"label": "ArtificiallySweetenedCoffee",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0100": {
				"label": "UnsweetenedCoffee",
				"daily_values": [0.455, 0.75, 0.75],
				"value": 0.6516666666666667
			},
			"BVS0200": {
				"label": "SweetenedCoffeeSubstitutes",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0200": {
				"label": "ArtificiallySweetenedCoffeeSubstitutes",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0200": {
				"label": "UnsweetenedCoffeeSubstitutes",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0600": {
				"label": "SweetenedWater",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0600": {
				"label": "ArtificiallySweetenedWater",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0500": {
				"label": "Water",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0700": {
				"label": "Nondairy-basedSweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0700": {
				"label": "Nondairy-basedArtificiallySweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0600": {
				"label": "Nondairy-basedUnsweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVO0100": {
				"label": "Non-alcoholicBeer",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVO0200": {
				"label": "Non-alcoholicLightBeer",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVE0100": {
				"label": "BeerandAles",
				"daily_values": [0.0, 0.0, 1.0],
				"value": 0.3333333333333333
			},
			"BVE0400": {
				"label": "CordialandLiqueur",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVE0300": {
				"label": "DistilledLiquor",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVE0200": {
				"label": "Wine",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0100": {
				"label": "Gravy",
				"daily_values": [0.0, 0.5, 0.0],
				"value": 0.1666666666666667
			},
			"MSC0200": {
				"label": "ReducedFatGravy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0300": {
				"label": "FattySauces",
				"daily_values": [0.0, 0.938, 0.487],
				"value": 0.4749999999999999
			},
			"MSC0400": {
				"label": "Sweet/SaltySauces",
				"daily_values": [5.125, 0.0, 3.0],
				"value": 2.708333333333333
			},
			"MSC0500": {
				"label": "PickledVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0600": {
				"label": "Misc",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0700": {
				"label": "Non-grainFlourandSimilar",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0800": {
				"label": "SoupBroth",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0900": {
				"label": "BabyFoodDessert",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC1000": {
				"label": "MiscellaneousBabyFoodMixtures",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW1300": {
				"label": "BabyFoodGrainMixtures–WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS1300": {
				"label": "BabyFoodGrainMixtures–SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"meta-fruit-juice": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"FRU0100": {
						"id": "FRU0100",
						"label": "CitrusJuice",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FRU0200": {
						"id": "FRU0200",
						"label": "FruitJuiceexcludingCitrusJuice",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "FruitJuice",
				"value": 0.0
			},
			"meta-fruit": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"FRU0300": {
						"id": "FRU0300",
						"label": "CitrusFruit",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					},
					"FRU0400": {
						"id": "FRU0400",
						"label": "FruitexcludingCitrusFruit",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Fruit",
				"value": 0.0
			},
			"meta-processed-fruits": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"FRU0600": {
						"id": "FRU0600",
						"label": "FriedFruits",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FRU0700": {
						"id": "FRU0700",
						"label": "Fruit-basedSavorySnack",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "ProcessedFruits",
				"value": 0.0
			},
			"meta-vegetables": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"VEG0100": {
						"id": "VEG0100",
						"label": "GreenLeafyVegetables",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					},
					"VEG0200": {
						"id": "VEG0200",
						"label": "Deep-yellowVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0300": {
						"id": "VEG0300",
						"label": "Tomato",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0400": {
						"id": "VEG0400",
						"label": "WhitePotatoes",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.1946666666666667
					},
					"VEG0450": {
						"id": "VEG0450",
						"label": "OtherStarchyVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0700": {
						"id": "VEG0700",
						"label": "Beans",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0600": {
						"id": "VEG0600",
						"label": "OtherVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.082
					},
					"MSC0500": {
						"id": "MSC0500",
						"label": "PickledVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Vegetables",
				"value": 0.2766666666666667
			},
			"meta-fried-vegetables": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"VEG0800": {
						"id": "VEG0800",
						"label": "FrenchFries",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.357
					},
					"VEG0900": {
						"id": "VEG0900",
						"label": "FriedVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "FriedVegetables",
				"value": 0.357
			},
			"meta-vegetable-juice": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"VEG0500": {
						"id": "VEG0500",
						"label": "VegetableJuice",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "VegetableJuice",
				"value": 0.0
			},
			"meta-beans-lentils": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"VEG0700": {
						"id": "VEG0700",
						"label": "Beans",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Beans&Lentils",
				"value": 0.0
			},
			"meta-nuts-seeds": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"MOF0500": {
						"id": "MOF0500",
						"label": "NutsandSeeds",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					},
					"MOF0600": {
						"id": "MOF0600",
						"label": "NutandSeedButters",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					}
				},
				"label": "Nuts&Seeds",
				"value": 0.0
			},
			"meta-whole-grains": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"GRW0100": {
						"id": "GRW0100",
						"label": "Grains,FlourandDryMixes-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0200": {
						"id": "GRW0200",
						"label": "Loaf-typeBreadandPlainRolls-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0300": {
						"id": "GRW0300",
						"label": "OtherBreads(quickbreads,cornmuffins,tortillas)-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0400": {
						"id": "GRW0400",
						"label": "Crackers-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0500": {
						"id": "GRW0500",
						"label": "Pasta-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0600": {
						"id": "GRW0600",
						"label": "Ready-to-eatCereal(notpresweetened)-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW1100": {
						"id": "GRW1100",
						"label": "Popcorn",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0700": {
						"id": "GRW0700",
						"label": "Ready-to-eatCereal(presweetened)-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0900": {
						"id": "GRW0900",
						"label": "SnackChips-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW1000": {
						"id": "GRW1000",
						"label": "SnackBars-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "WholeGrains",
				"value": 0.0
			},
			"meta-refined-grains": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"GRS0100": {
						"id": "GRS0100",
						"label": "Grains,FlourandDryMixes-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0100": {
						"id": "GRR0100",
						"label": "Grains,FlourandDryMixes-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3126666666666666
					},
					"GRS0200": {
						"id": "GRS0200",
						"label": "Loaf-typeBreadandPlainRolls-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0200": {
						"id": "GRR0200",
						"label": "Loaf-typeBreadandPlainRolls-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 2.279333333333333
					},
					"GRS0300": {
						"id": "GRS0300",
						"label": "OtherBreads(quickbreads,cornmuffins,tortillas)-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0300": {
						"id": "GRR0300",
						"label": "OtherBreads(quickbreads,cornmuffins,tortillas)-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.8346666666666667
					},
					"GRS0400": {
						"id": "GRS0400",
						"label": "Crackers-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0400": {
						"id": "GRR0400",
						"label": "Crackers-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0500": {
						"id": "GRS0500",
						"label": "Pasta-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0500": {
						"id": "GRR0500",
						"label": "Pasta-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.381
					},
					"GRS0600": {
						"id": "GRS0600",
						"label": "Ready-to-eatCereal(notpresweetened)-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0600": {
						"id": "GRR0600",
						"label": "Ready-to-eatCereal(notpresweetened)-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0700": {
						"id": "GRS0700",
						"label": "Ready-to-eatCereal(presweetened)-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0700": {
						"id": "GRR0700",
						"label": "Ready-to-eatCereal(presweetened)-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0800": {
						"id": "GRS0800",
						"label": "Cakes,Cookies,Pies,Pastries,Danish,DoughnutsandCobblers-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0800": {
						"id": "GRR0800",
						"label": "Cakes,Cookies,Pies,Pastries,Danish,DoughnutsandCobblers-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 2.432666666666667
					},
					"GRS1000": {
						"id": "GRS1000",
						"label": "SnackBars-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR1000": {
						"id": "GRR1000",
						"label": "SnackBars-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0900": {
						"id": "GRS0900",
						"label": "SnackChips-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0900": {
						"id": "GRR0900",
						"label": "SnackChips-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "RefinedGrains",
				"value": 6.240333333333332
			},
			"meta-full-fat-dairy-products": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"DMF0100": {
						"id": "DMF0100",
						"label": "WholeMilk",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DMF0200": {
						"id": "DMF0200",
						"label": "Ready-to-drinkFlavoredMilk-Whole",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DCF0100": {
						"id": "DCF0100",
						"label": "Cheese",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.3916666666666667
					},
					"DYF0100": {
						"id": "DYF0100",
						"label": "Yogurt-SweetenedWholeMilk",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYF0200": {
						"id": "DYF0200",
						"label": "Yogurt-ArtificiallySweetenedWholeMilk",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FCF0100": {
						"id": "FCF0100",
						"label": "Cream",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.2423333333333333
					}
				},
				"label": "Full-FatDairyProducts",
				"value": 0.634
			},
			"meta-reduced-or-non-fat-dairy-products": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"DMR0100": {
						"id": "DMR0100",
						"label": "Milk-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DMR0200": {
						"id": "DMR0200",
						"label": "Ready-to-drinkFlavoredMilk-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DCR0100": {
						"id": "DCR0100",
						"label": "Cheese-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.1333333333333333
					},
					"DYR0100": {
						"id": "DYR0100",
						"label": "Yogurt-SweetenedLowFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYR0200": {
						"id": "DYR0200",
						"label": "Yogurt-ArtificiallySweetenedLowFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FCR0100": {
						"id": "FCR0100",
						"label": "Cream-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DML0100": {
						"id": "DML0100",
						"label": "Milk-LowFatandFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DML0200": {
						"id": "DML0200",
						"label": "Ready-to-drinkFlavoredMilk-LowFatandFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DCL0100": {
						"id": "DCL0100",
						"label": "Cheese-LowFatandFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYL0100": {
						"id": "DYL0100",
						"label": "Yogurt-SweetenedFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYL0200": {
						"id": "DYL0200",
						"label": "Yogurt-ArtificiallySweetenedFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FCL0100": {
						"id": "FCL0100",
						"label": "Cream-LowFatandFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "ReducedorNon-FatDairyProducts",
				"value": 0.1333333333333333
			},
			"meta-dairy-based-desserts": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"DOT0100": {
						"id": "DOT0100",
						"label": "FrozenDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0300": {
						"id": "DOT0300",
						"label": "PuddingandOtherDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0400": {
						"id": "DOT0400",
						"label": "ArtificiallySweetenedPuddingandOtherDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Dairy-BasedDesserts",
				"value": 0.0
			},
			"meta-plant-based-dairy-alternatives": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"DMN0100": {
						"id": "DMN0100",
						"label": "Milk-Nondairy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.006333333333333333
					},
					"DCN0100": {
						"id": "DCN0100",
						"label": "Cheese-Nondairy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYN0100": {
						"id": "DYN0100",
						"label": "Yogurt-Nondairy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0200": {
						"id": "DOT0200",
						"label": "FrozenNondairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.2913333333333333
					},
					"FCN0100": {
						"id": "FCN0100",
						"label": "Cream-Nondairy,Soy,rice,grainbased",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 2.666666666666667
					}
				},
				"label": "Plant-BasedDairyAlternatives",
				"value": 2.964333333333333
			},
			"meta-processed-meat": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MCF0100": {
						"id": "MCF0100",
						"label": "ColdCutsandSausage",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.6703333333333333
					},
					"MCL0100": {
						"id": "MCL0100",
						"label": "LeanColdCutsandSausage",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MCF0200": {
						"id": "MCF0200",
						"label": "CuredPork",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MCL0200": {
						"id": "MCL0200",
						"label": "LeanCuredPork",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FMC0200": {
						"id": "FMC0200",
						"label": "Meat-basedSavorySnack",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "ProcessedMeat",
				"value": 0.6703333333333333
			},
			"meta-red-meat": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MRF0100": {
						"id": "MRF0100",
						"label": "Beef",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRL0100": {
						"id": "MRL0100",
						"label": "LeanBeef",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRF0200": {
						"id": "MRF0200",
						"label": "Veal",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRL0200": {
						"id": "MRL0200",
						"label": "LeanVeal",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRF0300": {
						"id": "MRF0300",
						"label": "Lamb",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRL0300": {
						"id": "MRL0300",
						"label": "LeanLamb",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRF0400": {
						"id": "MRF0400",
						"label": "FreshPork",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRL0400": {
						"id": "MRL0400",
						"label": "LeanFreshPork",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRF0500": {
						"id": "MRF0500",
						"label": "Game",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MOF0100": {
						"id": "MOF0100",
						"label": "OrganMeats",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "RedMeat",
				"value": 0.0
			},
			"meta-poultry": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": false,
				"children": {
					"MPF0100": {
						"id": "MPF0100",
						"label": "Poultry",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3293333333333333
					},
					"MPL0100": {
						"id": "MPL0100",
						"label": "LeanPoultry",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3173333333333333
					},
					"MPF0200": {
						"id": "MPF0200",
						"label": "FriedChicken",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 1.27
					}
				},
				"label": "Poultry",
				"value": 1.916666666666667
			},
			"meta-fish": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": false,
				"children": {
					"MFF0100": {
						"id": "MFF0100",
						"label": "Fish",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MFL0100": {
						"id": "MFL0100",
						"label": "LeanFish",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MFF0200": {
						"id": "MFF0200",
						"label": "FriedFish",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.6703333333333333
					}
				},
				"label": "Fish",
				"value": 0.6703333333333333
			},
			"meta-shellfish": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": false,
				"children": {
					"MSL0100": {
						"id": "MSL0100",
						"label": "Shellfish",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MSF0100": {
						"id": "MSF0100",
						"label": "FriedShellfish",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Shellfish",
				"value": 0.0
			},
			"meta-eggs": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MOF0300": {
						"id": "MOF0300",
						"label": "Eggs",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MOF0400": {
						"id": "MOF0400",
						"label": "EggSubstitute",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Eggs",
				"value": 0.0
			},
			"meta-plant-based-meat-alternatives": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"MOF0700": {
						"id": "MOF0700",
						"label": "MeatAlternatives",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Plant-BasedMeatAlternatives",
				"value": 0.0
			},
			"meta-saturated-unhealthy-fats": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"FMF0100": {
						"id": "FMF0100",
						"label": "Margarine",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FMR0100": {
						"id": "FMR0100",
						"label": "Margarine-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FSF0100": {
						"id": "FSF0100",
						"label": "Shortening",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.1816666666666667
					},
					"FAF0100": {
						"id": "FAF0100",
						"label": "Butter",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 1.333333333333333
					},
					"FAR0100": {
						"id": "FAR0100",
						"label": "ButterandOtherAnimalFats-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FDF0100": {
						"id": "FDF0100",
						"label": "CreamyDressings",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.1166666666666667
					},
					"FCF0100": {
						"id": "FCF0100",
						"label": "Cream",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.2423333333333333
					}
				},
				"label": "Saturated(Unhealthy)Fats",
				"value": 1.874
			},
			"meta-unsaturated-healthier-fats": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"FOF0100": {
						"id": "FOF0100",
						"label": "VegetableOils",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.904
					},
					"FRU0500": {
						"id": "FRU0500",
						"label": "Avocados",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					}
				},
				"label": "Unsaturated(Healthier)Fats",
				"value": 0.904
			},
			"meta-sweetened-beverages": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"BVS0400": {
						"id": "BVS0400",
						"label": "Soda",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 2.5
					},
					"BVS0300": {
						"id": "BVS0300",
						"label": "SweetenedFruitDrinks",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVS0500": {
						"id": "BVS0500",
						"label": "SweetenedTea",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVS0100": {
						"id": "BVS0100",
						"label": "SweetenedCoffee",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVS0200": {
						"id": "BVS0200",
						"label": "SweetenedCoffeeSubstitutes",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVS0600": {
						"id": "BVS0600",
						"label": "SweetenedWater",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVO0100": {
						"id": "BVO0100",
						"label": "Non-alcoholicBeer",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVO0200": {
						"id": "BVO0200",
						"label": "Non-alcoholicLightBeer",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "SweetenedBeverages",
				"value": 2.5
			},
			"meta-artificially-sweetened-beverages": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"BVA0500": {
						"id": "BVA0500",
						"label": "ArtificiallySweetenedTea",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVA0100": {
						"id": "BVA0100",
						"label": "ArtificiallySweetenedCoffee",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVA0200": {
						"id": "BVA0200",
						"label": "ArtificiallySweetenedCoffeeSubstitutes",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVA0600": {
						"id": "BVA0600",
						"label": "ArtificiallySweetenedWater",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVA0400": {
						"id": "BVA0400",
						"label": "DietSoda",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.5
					},
					"BVA0300": {
						"id": "BVA0300",
						"label": "ArtificiallySweetenedFruitDrinks",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "ArtificiallySweetenedBeverages",
				"value": 0.5
			},
			"meta-unsweetened-beverages": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"BVU0500": {
						"id": "BVU0500",
						"label": "Water",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					},
					"BVU0300": {
						"id": "BVU0300",
						"label": "UnsweetenedSoftDrinks",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVU0400": {
						"id": "BVU0400",
						"label": "UnsweetenedTea",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVU0100": {
						"id": "BVU0100",
						"label": "UnsweetenedCoffee",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.6516666666666667
					},
					"BVU0200": {
						"id": "BVU0200",
						"label": "UnsweetenedCoffeeSubstitutes",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "UnsweetenedBeverages",
				"value": 0.6516666666666667
			},
			"meta-alcoholic-beverages": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"BVE0100": {
						"id": "BVE0100",
						"label": "BeerandAles",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3333333333333333
					},
					"BVE0400": {
						"id": "BVE0400",
						"label": "CordialandLiqueur",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVE0300": {
						"id": "BVE0300",
						"label": "DistilledLiquor",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVE0200": {
						"id": "BVE0200",
						"label": "Wine",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "AlcoholicBeverages",
				"value": 0.3333333333333333
			},
			"meta-fried-foods": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MSF0100": {
						"id": "MSF0100",
						"label": "FriedShellfish",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MFF0200": {
						"id": "MFF0200",
						"label": "FriedFish",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.6703333333333333
					},
					"FMC0100": {
						"id": "FMC0100",
						"label": "Vegetable-basedSavorySnack",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0800": {
						"id": "VEG0800",
						"label": "FrenchFries",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.357
					},
					"VEG0900": {
						"id": "VEG0900",
						"label": "FriedVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FRU0600": {
						"id": "FRU0600",
						"label": "FriedFruits",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MPF0200": {
						"id": "MPF0200",
						"label": "FriedChicken",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 1.27
					}
				},
				"label": "FriedFoods",
				"value": 2.297333333333333
			},
			"meta-salty-snacks": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"GRS0900": {
						"id": "GRS0900",
						"label": "SnackChipsSomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0900": {
						"id": "GRR0900",
						"label": "SnackChips",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW1200": {
						"id": "GRW1200",
						"label": "FlavoredPopcorn",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FMC0100": {
						"id": "FMC0100",
						"label": "VegetableBasedSavorySnack(PotatoChips)",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FMC0200": {
						"id": "FMC0200",
						"label": "MeatBasedSavorySnack(PorkRinds)",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "SaltySnacks",
				"value": 0.0
			},
			"meta-sweets-desserts": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MSC0600": {
						"id": "MSC0600",
						"label": "Misc",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0100": {
						"id": "DOT0100",
						"label": "FrozenDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0200": {
						"id": "DOT0200",
						"label": "FrozenNondairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.2913333333333333
					},
					"DOT0300": {
						"id": "DOT0300",
						"label": "PuddingandOtherDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0400": {
						"id": "DOT0400",
						"label": "ArtificiallySweetenedPuddingandOtherDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0800": {
						"id": "GRW0800",
						"label": "WholeGrainCookies,Pies,Pastries,Danish,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0800": {
						"id": "GRS0800",
						"label": "SomeWholeGrainCookies,Pies,Pastries,Danish,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0800": {
						"id": "GRR0800",
						"label": "Cookies,Pies,Pastries,Danish,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 2.432666666666667
					},
					"GRS1000": {
						"id": "GRS1000",
						"label": "SnackBarsSomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR1000": {
						"id": "GRR1000",
						"label": "SnackBars",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0300": {
						"id": "GRR0300",
						"label": "RefinedSnackBreads",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.8346666666666667
					},
					"SWT0500": {
						"id": "SWT0500",
						"label": "Syrup,Honey,Jam",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.1516666666666667
					},
					"SWT0400": {
						"id": "SWT0400",
						"label": "Sugar",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 3.555333333333333
					},
					"SWT0700": {
						"id": "SWT0700",
						"label": "Fudge,caramel,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"SWT0100": {
						"id": "SWT0100",
						"label": "ChocolateCandy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.1333333333333333
					},
					"SWT0200": {
						"id": "SWT0200",
						"label": "Candy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.7236666666666666
					},
					"SWT0300": {
						"id": "SWT0300",
						"label": "Frostingoricing",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Sweets&Desserts",
				"value": 8.122666666666667
			},
			"meta-healthier-snacks": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"GRW1000": {
						"id": "GRW1000",
						"label": "WholeGrainSnackBars",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0900": {
						"id": "GRW0900",
						"label": "WholeGrainSnackChips",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW1100": {
						"id": "GRW1100",
						"label": "PlainPopcorn",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0300": {
						"id": "GRW0300",
						"label": "QuickandOtherBreads",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "HealthierSnacks",
				"value": 0.0
			},
			"meta-sweet-salty-condiments": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MSC0400": {
						"id": "MSC0400",
						"label": "Sweet/SaltySauces",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 2.708333333333333
					},
					"SWT0500": {
						"id": "SWT0500",
						"label": "Syrup,Honey,Jam",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.1516666666666667
					},
					"SWT0400": {
						"id": "SWT0400",
						"label": "Sugar",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 3.555333333333333
					},
					"SWT0700": {
						"id": "SWT0700",
						"label": "Fudge,caramel,butterscotch,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"SWT0300": {
						"id": "SWT0300",
						"label": "Frostingoricing",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Sweet/SaltyCondiments",
				"value": 6.415333333333334
			},
			"meta-fatty-condiments": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MSC0100": {
						"id": "MSC0100",
						"label": "Gravy",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.1666666666666667
					},
					"MSC0200": {
						"id": "MSC0200",
						"label": "ReducedFatGravy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MSC0300": {
						"id": "MSC0300",
						"label": "FattySauces",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.4749999999999999
					},
					"FCF0100": {
						"id": "FCF0100",
						"label": "Cream",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.2423333333333333
					},
					"FDF0100": {
						"id": "FDF0100",
						"label": "CreamyDressings",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.1166666666666667
					}
				},
				"label": "FattyCondiments",
				"value": 1.000666666666667
			}
		},
		"active": true
	}, {
		"id": 91,
		"name": "Pescatarian",
		"code": "PES",
		"quality": 1,
		"longName": "Pescatarianquality1(1outof10)",
		"description": "Thisdietarypatternistypicallybasedmainlyonrefinedgrains,desserts,sugary/fatty/saltysnacks,highlyprocessedfoods,sweets,friedfoods,processedfish/seafood,eggs(optional),sweetenedbeverages,andfastfood/takeout.",
		"hei": 17,
		"calories": 2093.377666666667,
		"adjustedCalories": "",
		"fingerprintPhotoUrl": "https://dqpn.imgix.net/assets/diet-images/91_PES/1/fingerprint_photo_LrbHpEpgFVEGaWhPpDtHiPmHfyITeb.png?w=960&auto=format,compression&txtalign=bottom%2Cright&txtclr=c1cdbd&txt=%C2%A9%202022%20Diet%20ID%20Inc&txtsize=36&txtfont=Arial%2CBoldMT&txtpad=15&txtalign=center",
		"foodGroupValues": {
			"FRU0100": 0.0,
			"FRU0200": 0.0,
			"FRU0300": 0.0,
			"FRU0400": 0.0,
			"FRU0500": 0.0,
			"FRU0600": 0.0,
			"FRU0700": 0.0,
			"VEG0100": 0.0,
			"VEG0200": 0.0,
			"VEG0300": 0.05633333333333334,
			"VEG0400": 0.0,
			"VEG0800": 0.5,
			"VEG0450": 0.0,
			"VEG0700": 0.0,
			"VEG0600": 0.0,
			"VEG0900": 1.264,
			"VEG0500": 0.0,
			"FMC0100": 0.0,
			"GRW0100": 0.0,
			"GRS0100": 0.0,
			"GRR0100": 2.133666666666667,
			"GRW0200": 0.0,
			"GRS0200": 0.0,
			"GRR0200": 2.139666666666667,
			"GRW0300": 0.0,
			"GRS0300": 0.0,
			"GRR0300": 0.3246666666666667,
			"GRW0400": 0.0,
			"GRS0400": 0.0,
			"GRR0400": 0.0,
			"GRW0500": 0.0,
			"GRS0500": 0.0,
			"GRR0500": 0.7143333333333333,
			"GRW0600": 0.0,
			"GRS0600": 0.0,
			"GRR0600": 0.0,
			"GRW0700": 0.0,
			"GRS0700": 0.341,
			"GRR0700": 0.0,
			"GRW0800": 0.0,
			"GRS0800": 0.0,
			"GRR0800": 1.812666666666667,
			"GRW1000": 0.0,
			"GRS1000": 0.0,
			"GRR1000": 0.0,
			"GRW0900": 0.0,
			"GRS0900": 0.0,
			"GRR0900": 0.6666666666666666,
			"GRW1100": 0.0,
			"GRW1200": 0.0,
			"GRR1300": 0.0,
			"MRF0100": 0.0,
			"MRL0100": 0.0,
			"MRF0200": 0.0,
			"MRL0200": 0.0,
			"MRF0300": 0.0,
			"MRL0300": 0.0,
			"MRF0400": 0.0,
			"MRL0400": 0.0,
			"MCF0200": 0.0,
			"MCL0200": 0.0,
			"MRF0500": 0.0,
			"MPF0100": 0.0,
			"MPL0100": 0.0,
			"MPF0200": 0.0,
			"MFF0100": 0.0,
			"MFL0100": 0.4466666666666667,
			"MFF0200": 0.0,
			"MSL0100": 1.0,
			"MSF0100": 0.0,
			"MCF0100": 0.0,
			"MCL0100": 0.0,
			"MOF0100": 0.0,
			"MOF0200": 0.0,
			"FMC0200": 0.0,
			"MOF0300": 0.0,
			"MOF0400": 0.0,
			"MOF0500": 0.0,
			"MOF0600": 0.0,
			"MOF0700": 0.0,
			"DMF0100": 0.1666666666666667,
			"DMR0100": 0.0,
			"DML0100": 0.0,
			"DMN0100": 0.0,
			"DMF0200": 0.0,
			"DMR0200": 0.0,
			"DML0200": 0.0,
			"DML0300": 0.0,
			"DML0400": 0.0,
			"SWT0600": 0.0,
			"MSC1100": 0.0,
			"DCF0100": 0.291,
			"DCR0100": 0.4723333333333333,
			"DCL0100": 0.0,
			"DCN0100": 0.0,
			"DYF0100": 0.0,
			"DYR0100": 0.0,
			"DYL0100": 0.0,
			"DYF0200": 0.0,
			"DYR0200": 0.0,
			"DYL0200": 0.0,
			"DYN0100": 0.0,
			"DOT0100": 0.0,
			"DOT0200": 0.0,
			"DOT0300": 0.0,
			"DOT0400": 0.0,
			"FCF0100": 0.3333333333333333,
			"FCR0100": 1.580333333333333,
			"FCL0100": 0.0,
			"FCN0100": 0.0,
			"DOT0500": 0.0,
			"DOT0600": 0.0,
			"DOT0700": 0.0,
			"DOT0800": 0.0,
			"FMF0100": 0.0,
			"FMR0100": 0.0,
			"FOF0100": 2.906666666666666,
			"FSF0100": 0.0,
			"FAF0100": 1.833333333333333,
			"FAR0100": 0.0,
			"FDF0100": 0.0,
			"FDR0100": 0.0,
			"SWT0400": 2.609666666666667,
			"MSC1200": 0.0,
			"SWT0500": 0.3333333333333333,
			"SWT0700": 0.0,
			"SWT0800": 0.0,
			"SWT0100": 0.1416666666666667,
			"SWT0200": 0.0,
			"SWT0300": 0.0,
			"BVS0400": 2.0,
			"BVA0400": 1.0,
			"BVU0300": 0.0,
			"BVS0300": 0.3333333333333333,
			"BVA0300": 0.0,
			"BVS0500": 0.5,
			"BVA0500": 0.0,
			"BVU0400": 0.0,
			"BVS0100": 0.0,
			"BVA0100": 0.0,
			"BVU0100": 0.04933333333333333,
			"BVS0200": 0.0,
			"BVA0200": 0.0,
			"BVU0200": 0.0,
			"BVS0600": 0.0,
			"BVA0600": 0.0,
			"BVU0500": 0.0,
			"BVS0700": 0.0,
			"BVA0700": 0.0,
			"BVU0600": 0.0,
			"BVO0100": 0.0,
			"BVO0200": 0.0,
			"BVE0100": 0.0,
			"BVE0400": 0.0,
			"BVE0300": 0.0,
			"BVE0200": 0.0,
			"MSC0100": 0.0,
			"MSC0200": 0.0,
			"MSC0300": 0.3686666666666666,
			"MSC0400": 3.208333333333333,
			"MSC0500": 0.0,
			"MSC0600": 0.0,
			"MSC0700": 0.0,
			"MSC0800": 0.0,
			"MSC0900": 0.0,
			"MSC1000": 0.0,
			"GRW1300": 0.0,
			"GRS1300": 0.0
		},
		"foodGroupInfo": {
			"FRU0100": {
				"label": "CitrusJuice",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0200": {
				"label": "FruitJuiceexcludingCitrusJuice",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0300": {
				"label": "CitrusFruit",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0400": {
				"label": "FruitexcludingCitrusFruit",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0500": {
				"label": "Avocados",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0600": {
				"label": "FriedFruits",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FRU0700": {
				"label": "Fruit-basedSavorySnack",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0100": {
				"label": "GreenLeafyVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0200": {
				"label": "Deep-yellowVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0300": {
				"label": "Tomato",
				"daily_values": [0.0, 0.169, 0.0],
				"value": 0.05633333333333334
			},
			"VEG0400": {
				"label": "WhitePotatoes",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0800": {
				"label": "FrenchFries",
				"daily_values": [0.0, 0.9, 0.6],
				"value": 0.5
			},
			"VEG0450": {
				"label": "OtherStarchyVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0700": {
				"label": "Beans",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0600": {
				"label": "OtherVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"VEG0900": {
				"label": "FriedVegetables",
				"daily_values": [3.792, 0.0, 0.0],
				"value": 1.264
			},
			"VEG0500": {
				"label": "VegetableJuice",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FMC0100": {
				"label": "VegetableBasedSavorySnack(PotatoChips)",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0100": {
				"label": "Grains,FlourandDryMixes-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0100": {
				"label": "Grains,FlourandDryMixes-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0100": {
				"label": "Grains,FlourandDryMixes-RefinedGrain",
				"daily_values": [0.0, 4.859, 1.542],
				"value": 2.133666666666667
			},
			"GRW0200": {
				"label": "Loaf-typeBreadandPlainRolls-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0200": {
				"label": "Loaf-typeBreadandPlainRolls-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0200": {
				"label": "Loaf-typeBreadandPlainRolls-RefinedGrain",
				"daily_values": [3.0, 2.419, 1.0],
				"value": 2.139666666666667
			},
			"GRW0300": {
				"label": "QuickandOtherBreads",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0300": {
				"label": "OtherBreads(quickbreads,cornmuffins,tortillas)-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0300": {
				"label": "RefinedSnackBreads",
				"daily_values": [0.0, 0.974, 0.0],
				"value": 0.3246666666666667
			},
			"GRW0400": {
				"label": "Crackers-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0400": {
				"label": "Crackers-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0400": {
				"label": "Crackers-RefinedGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0500": {
				"label": "Pasta-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0500": {
				"label": "Pasta-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0500": {
				"label": "Pasta-RefinedGrain",
				"daily_values": [1.143, 0.0, 1.0],
				"value": 0.7143333333333333
			},
			"GRW0600": {
				"label": "Ready-to-eatCereal(notpresweetened)-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0600": {
				"label": "Ready-to-eatCereal(notpresweetened)-SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0600": {
				"label": "Ready-to-eatCereal(notpresweetened)-RefinedGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0700": {
				"label": "Ready-to-eatCereal(presweetened)-WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0700": {
				"label": "Ready-to-eatCereal(presweetened)-SomeWholeGrain",
				"daily_values": [1.023, 0.0, 0.0],
				"value": 0.341
			},
			"GRR0700": {
				"label": "Ready-to-eatCereal(presweetened)-RefinedGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0800": {
				"label": "WholeGrainCookies,Pies,Pastries,Danish,etc.",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0800": {
				"label": "SomeWholeGrainCookies,Pies,Pastries,Danish,etc.",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0800": {
				"label": "Cookies,Pies,Pastries,Danish,etc.",
				"daily_values": [1.453, 0.333, 3.652],
				"value": 1.812666666666667
			},
			"GRW1000": {
				"label": "WholeGrainSnackBars",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS1000": {
				"label": "SnackBarsSomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR1000": {
				"label": "SnackBars",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW0900": {
				"label": "WholeGrainSnackChips",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS0900": {
				"label": "SnackChipsSomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR0900": {
				"label": "SnackChips",
				"daily_values": [1.0, 1.0, 0.0],
				"value": 0.6666666666666666
			},
			"GRW1100": {
				"label": "PlainPopcorn",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW1200": {
				"label": "FlavoredPopcorn",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRR1300": {
				"label": "BabyFoodGrainMixtures–RefinedGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0100": {
				"label": "Beef",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRL0100": {
				"label": "LeanBeef",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0200": {
				"label": "Veal",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRL0200": {
				"label": "LeanVeal",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0300": {
				"label": "Lamb",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRL0300": {
				"label": "LeanLamb",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0400": {
				"label": "FreshPork",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRL0400": {
				"label": "LeanFreshPork",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MCF0200": {
				"label": "CuredPork",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MCL0200": {
				"label": "LeanCuredPork",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MRF0500": {
				"label": "Game",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MPF0100": {
				"label": "Poultry",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MPL0100": {
				"label": "LeanPoultry",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MPF0200": {
				"label": "FriedChicken",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MFF0100": {
				"label": "Fish",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MFL0100": {
				"label": "LeanFish",
				"daily_values": [0.0, 1.34, 0.0],
				"value": 0.4466666666666667
			},
			"MFF0200": {
				"label": "FriedFish",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSL0100": {
				"label": "Shellfish",
				"daily_values": [0.0, 0.0, 3.0],
				"value": 1.0
			},
			"MSF0100": {
				"label": "FriedShellfish",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MCF0100": {
				"label": "ColdCutsandSausage",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MCL0100": {
				"label": "LeanColdCutsandSausage",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0100": {
				"label": "OrganMeats",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0200": {
				"label": "BabyFoodMeatMixtures",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FMC0200": {
				"label": "MeatBasedSavorySnack(PorkRinds)",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0300": {
				"label": "Eggs",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0400": {
				"label": "EggSubstitute",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0500": {
				"label": "NutsandSeeds",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0600": {
				"label": "NutandSeedButters",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MOF0700": {
				"label": "MeatAlternatives",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DMF0100": {
				"label": "WholeMilk",
				"daily_values": [0.5, 0.0, 0.0],
				"value": 0.1666666666666667
			},
			"DMR0100": {
				"label": "Milk-ReducedFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DML0100": {
				"label": "Milk-LowFatandFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DMN0100": {
				"label": "Milk-Nondairy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DMF0200": {
				"label": "Ready-to-drinkFlavoredMilk-Whole",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DMR0200": {
				"label": "Ready-to-drinkFlavoredMilk-ReducedFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DML0200": {
				"label": "Ready-to-drinkFlavoredMilk-LowFatandFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DML0300": {
				"label": "SweetenedFlavoredMilkBeveragePowderwithNon-fatDryMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DML0400": {
				"label": "ArtificiallySweetenedFlavoredMilkBeveragePowderwithNon-fatDryMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0600": {
				"label": "SweetenedFlavoredMilkBeveragePowderwithoutNon-fatDryMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC1100": {
				"label": "ArtificiallySweetenedFlavoredMilkBeveragePowderwithoutNon-fatDryMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DCF0100": {
				"label": "Cheese",
				"daily_values": [0.75, 0.123, 0.0],
				"value": 0.291
			},
			"DCR0100": {
				"label": "Cheese-ReducedFat",
				"daily_values": [0.0, 1.417, 0.0],
				"value": 0.4723333333333333
			},
			"DCL0100": {
				"label": "Cheese-LowFatandFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DCN0100": {
				"label": "Cheese-Nondairy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYF0100": {
				"label": "Yogurt-SweetenedWholeMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYR0100": {
				"label": "Yogurt-SweetenedLowFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYL0100": {
				"label": "Yogurt-SweetenedFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYF0200": {
				"label": "Yogurt-ArtificiallySweetenedWholeMilk",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYR0200": {
				"label": "Yogurt-ArtificiallySweetenedLowFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYL0200": {
				"label": "Yogurt-ArtificiallySweetenedFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DYN0100": {
				"label": "Yogurt-Nondairy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0100": {
				"label": "FrozenDairyDessert",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0200": {
				"label": "FrozenNondairyDessert",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0300": {
				"label": "PuddingandOtherDairyDessert",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0400": {
				"label": "ArtificiallySweetenedPuddingandOtherDairyDessert",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FCF0100": {
				"label": "Cream",
				"daily_values": [1.0, 0.0, 0.0],
				"value": 0.3333333333333333
			},
			"FCR0100": {
				"label": "Cream-ReducedFat",
				"daily_values": [4.741, 0.0, 0.0],
				"value": 1.580333333333333
			},
			"FCL0100": {
				"label": "Cream-LowFatandFatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FCN0100": {
				"label": "Cream-Nondairy,Soy,rice,grainbased",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0500": {
				"label": "Dairy-basedSweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0600": {
				"label": "Dairy-basedArtificiallySweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0700": {
				"label": "InfantFormula",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"DOT0800": {
				"label": "InfantFormula-Nondairy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FMF0100": {
				"label": "Margarine",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FMR0100": {
				"label": "Margarine-ReducedFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FOF0100": {
				"label": "VegetableOils",
				"daily_values": [1.391, 4.329, 3.0],
				"value": 2.906666666666666
			},
			"FSF0100": {
				"label": "Shortening",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FAF0100": {
				"label": "Butter",
				"daily_values": [3.0, 1.5, 1.0],
				"value": 1.833333333333333
			},
			"FAR0100": {
				"label": "ButterandOtherAnimalFats-ReducedFat",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FDF0100": {
				"label": "CreamyDressings",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"FDR0100": {
				"label": "SaladDressing-ReducedFat/ReducedCalorie/FatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0400": {
				"label": "Sugar",
				"daily_values": [7.454, 0.375, 0.0],
				"value": 2.609666666666667
			},
			"MSC1200": {
				"label": "SugarSubstitute",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0500": {
				"label": "Syrup,Honey,Jam",
				"daily_values": [0.0, 1.0, 0.0],
				"value": 0.3333333333333333
			},
			"SWT0700": {
				"label": "Fudge,caramel,butterscotch,etc.",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0800": {
				"label": "Sauces,Sweet-ReducedFat/ReducedCalorie/FatFree",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0100": {
				"label": "ChocolateCandy",
				"daily_values": [0.0, 0.0, 0.425],
				"value": 0.1416666666666667
			},
			"SWT0200": {
				"label": "Candy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"SWT0300": {
				"label": "Frostingoricing",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0400": {
				"label": "Soda",
				"daily_values": [1.5, 3.0, 1.5],
				"value": 2.0
			},
			"BVA0400": {
				"label": "DietSoda",
				"daily_values": [1.5, 0.0, 1.5],
				"value": 1.0
			},
			"BVU0300": {
				"label": "UnsweetenedSoftDrinks",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0300": {
				"label": "SweetenedFruitDrinks",
				"daily_values": [0.0, 1.0, 0.0],
				"value": 0.3333333333333333
			},
			"BVA0300": {
				"label": "ArtificiallySweetenedFruitDrinks",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0500": {
				"label": "SweetenedTea",
				"daily_values": [0.0, 0.0, 1.5],
				"value": 0.5
			},
			"BVA0500": {
				"label": "ArtificiallySweetenedTea",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0400": {
				"label": "UnsweetenedTea",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0100": {
				"label": "SweetenedCoffee",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0100": {
				"label": "ArtificiallySweetenedCoffee",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0100": {
				"label": "UnsweetenedCoffee",
				"daily_values": [0.148, 0.0, 0.0],
				"value": 0.04933333333333333
			},
			"BVS0200": {
				"label": "SweetenedCoffeeSubstitutes",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0200": {
				"label": "ArtificiallySweetenedCoffeeSubstitutes",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0200": {
				"label": "UnsweetenedCoffeeSubstitutes",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0600": {
				"label": "SweetenedWater",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0600": {
				"label": "ArtificiallySweetenedWater",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0500": {
				"label": "Water",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVS0700": {
				"label": "Nondairy-basedSweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVA0700": {
				"label": "Nondairy-basedArtificiallySweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVU0600": {
				"label": "Nondairy-basedUnsweetenedMealReplacement/Supplement",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVO0100": {
				"label": "Non-alcoholicBeer",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVO0200": {
				"label": "Non-alcoholicLightBeer",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVE0100": {
				"label": "BeerandAles",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVE0400": {
				"label": "CordialandLiqueur",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVE0300": {
				"label": "DistilledLiquor",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"BVE0200": {
				"label": "Wine",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0100": {
				"label": "Gravy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0200": {
				"label": "ReducedFatGravy",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0300": {
				"label": "FattySauces",
				"daily_values": [0.0, 0.626, 0.48],
				"value": 0.3686666666666666
			},
			"MSC0400": {
				"label": "Sweet/SaltySauces",
				"daily_values": [4.125, 2.0, 3.5],
				"value": 3.208333333333333
			},
			"MSC0500": {
				"label": "PickledVegetables",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0600": {
				"label": "Misc",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0700": {
				"label": "Non-grainFlourandSimilar",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0800": {
				"label": "SoupBroth",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC0900": {
				"label": "BabyFoodDessert",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"MSC1000": {
				"label": "MiscellaneousBabyFoodMixtures",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRW1300": {
				"label": "BabyFoodGrainMixtures–WholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"GRS1300": {
				"label": "BabyFoodGrainMixtures–SomeWholeGrain",
				"daily_values": [0.0, 0.0, 0.0],
				"value": 0.0
			},
			"meta-fruit-juice": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"FRU0100": {
						"id": "FRU0100",
						"label": "CitrusJuice",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FRU0200": {
						"id": "FRU0200",
						"label": "FruitJuiceexcludingCitrusJuice",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "FruitJuice",
				"value": 0.0
			},
			"meta-fruit": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"FRU0300": {
						"id": "FRU0300",
						"label": "CitrusFruit",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					},
					"FRU0400": {
						"id": "FRU0400",
						"label": "FruitexcludingCitrusFruit",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Fruit",
				"value": 0.0
			},
			"meta-processed-fruits": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"FRU0600": {
						"id": "FRU0600",
						"label": "FriedFruits",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FRU0700": {
						"id": "FRU0700",
						"label": "Fruit-basedSavorySnack",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "ProcessedFruits",
				"value": 0.0
			},
			"meta-vegetables": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"VEG0100": {
						"id": "VEG0100",
						"label": "GreenLeafyVegetables",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					},
					"VEG0200": {
						"id": "VEG0200",
						"label": "Deep-yellowVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0300": {
						"id": "VEG0300",
						"label": "Tomato",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.05633333333333334
					},
					"VEG0400": {
						"id": "VEG0400",
						"label": "WhitePotatoes",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0450": {
						"id": "VEG0450",
						"label": "OtherStarchyVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0700": {
						"id": "VEG0700",
						"label": "Beans",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0600": {
						"id": "VEG0600",
						"label": "OtherVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MSC0500": {
						"id": "MSC0500",
						"label": "PickledVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Vegetables",
				"value": 0.05633333333333334
			},
			"meta-fried-vegetables": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"VEG0800": {
						"id": "VEG0800",
						"label": "FrenchFries",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.5
					},
					"VEG0900": {
						"id": "VEG0900",
						"label": "FriedVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 1.264
					}
				},
				"label": "FriedVegetables",
				"value": 1.764
			},
			"meta-vegetable-juice": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"VEG0500": {
						"id": "VEG0500",
						"label": "VegetableJuice",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "VegetableJuice",
				"value": 0.0
			},
			"meta-beans-lentils": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"VEG0700": {
						"id": "VEG0700",
						"label": "Beans",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Beans&Lentils",
				"value": 0.0
			},
			"meta-nuts-seeds": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"MOF0500": {
						"id": "MOF0500",
						"label": "NutsandSeeds",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					},
					"MOF0600": {
						"id": "MOF0600",
						"label": "NutandSeedButters",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					}
				},
				"label": "Nuts&Seeds",
				"value": 0.0
			},
			"meta-whole-grains": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"GRW0100": {
						"id": "GRW0100",
						"label": "Grains,FlourandDryMixes-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0200": {
						"id": "GRW0200",
						"label": "Loaf-typeBreadandPlainRolls-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0300": {
						"id": "GRW0300",
						"label": "OtherBreads(quickbreads,cornmuffins,tortillas)-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0400": {
						"id": "GRW0400",
						"label": "Crackers-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0500": {
						"id": "GRW0500",
						"label": "Pasta-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0600": {
						"id": "GRW0600",
						"label": "Ready-to-eatCereal(notpresweetened)-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW1100": {
						"id": "GRW1100",
						"label": "Popcorn",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0700": {
						"id": "GRW0700",
						"label": "Ready-to-eatCereal(presweetened)-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0900": {
						"id": "GRW0900",
						"label": "SnackChips-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW1000": {
						"id": "GRW1000",
						"label": "SnackBars-WholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "WholeGrains",
				"value": 0.0
			},
			"meta-refined-grains": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"GRS0100": {
						"id": "GRS0100",
						"label": "Grains,FlourandDryMixes-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0100": {
						"id": "GRR0100",
						"label": "Grains,FlourandDryMixes-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 2.133666666666667
					},
					"GRS0200": {
						"id": "GRS0200",
						"label": "Loaf-typeBreadandPlainRolls-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0200": {
						"id": "GRR0200",
						"label": "Loaf-typeBreadandPlainRolls-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 2.139666666666667
					},
					"GRS0300": {
						"id": "GRS0300",
						"label": "OtherBreads(quickbreads,cornmuffins,tortillas)-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0300": {
						"id": "GRR0300",
						"label": "OtherBreads(quickbreads,cornmuffins,tortillas)-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3246666666666667
					},
					"GRS0400": {
						"id": "GRS0400",
						"label": "Crackers-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0400": {
						"id": "GRR0400",
						"label": "Crackers-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0500": {
						"id": "GRS0500",
						"label": "Pasta-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0500": {
						"id": "GRR0500",
						"label": "Pasta-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.7143333333333333
					},
					"GRS0600": {
						"id": "GRS0600",
						"label": "Ready-to-eatCereal(notpresweetened)-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0600": {
						"id": "GRR0600",
						"label": "Ready-to-eatCereal(notpresweetened)-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0700": {
						"id": "GRS0700",
						"label": "Ready-to-eatCereal(presweetened)-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.341
					},
					"GRR0700": {
						"id": "GRR0700",
						"label": "Ready-to-eatCereal(presweetened)-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0800": {
						"id": "GRS0800",
						"label": "Cakes,Cookies,Pies,Pastries,Danish,DoughnutsandCobblers-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0800": {
						"id": "GRR0800",
						"label": "Cakes,Cookies,Pies,Pastries,Danish,DoughnutsandCobblers-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 1.812666666666667
					},
					"GRS1000": {
						"id": "GRS1000",
						"label": "SnackBars-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR1000": {
						"id": "GRR1000",
						"label": "SnackBars-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0900": {
						"id": "GRS0900",
						"label": "SnackChips-SomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0900": {
						"id": "GRR0900",
						"label": "SnackChips-RefinedGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.6666666666666666
					}
				},
				"label": "RefinedGrains",
				"value": 8.132666666666667
			},
			"meta-full-fat-dairy-products": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"DMF0100": {
						"id": "DMF0100",
						"label": "WholeMilk",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.1666666666666667
					},
					"DMF0200": {
						"id": "DMF0200",
						"label": "Ready-to-drinkFlavoredMilk-Whole",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DCF0100": {
						"id": "DCF0100",
						"label": "Cheese",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.291
					},
					"DYF0100": {
						"id": "DYF0100",
						"label": "Yogurt-SweetenedWholeMilk",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYF0200": {
						"id": "DYF0200",
						"label": "Yogurt-ArtificiallySweetenedWholeMilk",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FCF0100": {
						"id": "FCF0100",
						"label": "Cream",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.3333333333333333
					}
				},
				"label": "Full-FatDairyProducts",
				"value": 0.7909999999999999
			},
			"meta-reduced-or-non-fat-dairy-products": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"DMR0100": {
						"id": "DMR0100",
						"label": "Milk-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DMR0200": {
						"id": "DMR0200",
						"label": "Ready-to-drinkFlavoredMilk-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DCR0100": {
						"id": "DCR0100",
						"label": "Cheese-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.4723333333333333
					},
					"DYR0100": {
						"id": "DYR0100",
						"label": "Yogurt-SweetenedLowFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYR0200": {
						"id": "DYR0200",
						"label": "Yogurt-ArtificiallySweetenedLowFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FCR0100": {
						"id": "FCR0100",
						"label": "Cream-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 1.580333333333333
					},
					"DML0100": {
						"id": "DML0100",
						"label": "Milk-LowFatandFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DML0200": {
						"id": "DML0200",
						"label": "Ready-to-drinkFlavoredMilk-LowFatandFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DCL0100": {
						"id": "DCL0100",
						"label": "Cheese-LowFatandFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYL0100": {
						"id": "DYL0100",
						"label": "Yogurt-SweetenedFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYL0200": {
						"id": "DYL0200",
						"label": "Yogurt-ArtificiallySweetenedFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FCL0100": {
						"id": "FCL0100",
						"label": "Cream-LowFatandFatFree",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "ReducedorNon-FatDairyProducts",
				"value": 2.052666666666667
			},
			"meta-dairy-based-desserts": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"DOT0100": {
						"id": "DOT0100",
						"label": "FrozenDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0300": {
						"id": "DOT0300",
						"label": "PuddingandOtherDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0400": {
						"id": "DOT0400",
						"label": "ArtificiallySweetenedPuddingandOtherDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Dairy-BasedDesserts",
				"value": 0.0
			},
			"meta-plant-based-dairy-alternatives": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"DMN0100": {
						"id": "DMN0100",
						"label": "Milk-Nondairy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DCN0100": {
						"id": "DCN0100",
						"label": "Cheese-Nondairy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DYN0100": {
						"id": "DYN0100",
						"label": "Yogurt-Nondairy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0200": {
						"id": "DOT0200",
						"label": "FrozenNondairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FCN0100": {
						"id": "FCN0100",
						"label": "Cream-Nondairy,Soy,rice,grainbased",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Plant-BasedDairyAlternatives",
				"value": 0.0
			},
			"meta-processed-meat": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MCF0100": {
						"id": "MCF0100",
						"label": "ColdCutsandSausage",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MCL0100": {
						"id": "MCL0100",
						"label": "LeanColdCutsandSausage",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MCF0200": {
						"id": "MCF0200",
						"label": "CuredPork",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MCL0200": {
						"id": "MCL0200",
						"label": "LeanCuredPork",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FMC0200": {
						"id": "FMC0200",
						"label": "Meat-basedSavorySnack",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "ProcessedMeat",
				"value": 0.0
			},
			"meta-red-meat": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MRF0100": {
						"id": "MRF0100",
						"label": "Beef",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRL0100": {
						"id": "MRL0100",
						"label": "LeanBeef",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRF0200": {
						"id": "MRF0200",
						"label": "Veal",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRL0200": {
						"id": "MRL0200",
						"label": "LeanVeal",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRF0300": {
						"id": "MRF0300",
						"label": "Lamb",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRL0300": {
						"id": "MRL0300",
						"label": "LeanLamb",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRF0400": {
						"id": "MRF0400",
						"label": "FreshPork",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRL0400": {
						"id": "MRL0400",
						"label": "LeanFreshPork",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MRF0500": {
						"id": "MRF0500",
						"label": "Game",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MOF0100": {
						"id": "MOF0100",
						"label": "OrganMeats",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "RedMeat",
				"value": 0.0
			},
			"meta-poultry": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": false,
				"children": {
					"MPF0100": {
						"id": "MPF0100",
						"label": "Poultry",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MPL0100": {
						"id": "MPL0100",
						"label": "LeanPoultry",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MPF0200": {
						"id": "MPF0200",
						"label": "FriedChicken",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Poultry",
				"value": 0.0
			},
			"meta-fish": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": false,
				"children": {
					"MFF0100": {
						"id": "MFF0100",
						"label": "Fish",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MFL0100": {
						"id": "MFL0100",
						"label": "LeanFish",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.4466666666666667
					},
					"MFF0200": {
						"id": "MFF0200",
						"label": "FriedFish",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Fish",
				"value": 0.4466666666666667
			},
			"meta-shellfish": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": false,
				"children": {
					"MSL0100": {
						"id": "MSL0100",
						"label": "Shellfish",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 1.0
					},
					"MSF0100": {
						"id": "MSF0100",
						"label": "FriedShellfish",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Shellfish",
				"value": 1.0
			},
			"meta-eggs": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MOF0300": {
						"id": "MOF0300",
						"label": "Eggs",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MOF0400": {
						"id": "MOF0400",
						"label": "EggSubstitute",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Eggs",
				"value": 0.0
			},
			"meta-plant-based-meat-alternatives": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"MOF0700": {
						"id": "MOF0700",
						"label": "MeatAlternatives",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Plant-BasedMeatAlternatives",
				"value": 0.0
			},
			"meta-saturated-unhealthy-fats": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"FMF0100": {
						"id": "FMF0100",
						"label": "Margarine",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FMR0100": {
						"id": "FMR0100",
						"label": "Margarine-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FSF0100": {
						"id": "FSF0100",
						"label": "Shortening",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FAF0100": {
						"id": "FAF0100",
						"label": "Butter",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 1.833333333333333
					},
					"FAR0100": {
						"id": "FAR0100",
						"label": "ButterandOtherAnimalFats-ReducedFat",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FDF0100": {
						"id": "FDF0100",
						"label": "CreamyDressings",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FCF0100": {
						"id": "FCF0100",
						"label": "Cream",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.3333333333333333
					}
				},
				"label": "Saturated(Unhealthy)Fats",
				"value": 2.166666666666667
			},
			"meta-unsaturated-healthier-fats": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"FOF0100": {
						"id": "FOF0100",
						"label": "VegetableOils",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 2.906666666666666
					},
					"FRU0500": {
						"id": "FRU0500",
						"label": "Avocados",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					}
				},
				"label": "Unsaturated(Healthier)Fats",
				"value": 2.906666666666666
			},
			"meta-sweetened-beverages": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"BVS0400": {
						"id": "BVS0400",
						"label": "Soda",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 2.0
					},
					"BVS0300": {
						"id": "BVS0300",
						"label": "SweetenedFruitDrinks",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3333333333333333
					},
					"BVS0500": {
						"id": "BVS0500",
						"label": "SweetenedTea",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.5
					},
					"BVS0100": {
						"id": "BVS0100",
						"label": "SweetenedCoffee",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVS0200": {
						"id": "BVS0200",
						"label": "SweetenedCoffeeSubstitutes",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVS0600": {
						"id": "BVS0600",
						"label": "SweetenedWater",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVO0100": {
						"id": "BVO0100",
						"label": "Non-alcoholicBeer",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVO0200": {
						"id": "BVO0200",
						"label": "Non-alcoholicLightBeer",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "SweetenedBeverages",
				"value": 2.833333333333333
			},
			"meta-artificially-sweetened-beverages": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"BVA0500": {
						"id": "BVA0500",
						"label": "ArtificiallySweetenedTea",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVA0100": {
						"id": "BVA0100",
						"label": "ArtificiallySweetenedCoffee",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVA0200": {
						"id": "BVA0200",
						"label": "ArtificiallySweetenedCoffeeSubstitutes",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVA0600": {
						"id": "BVA0600",
						"label": "ArtificiallySweetenedWater",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVA0400": {
						"id": "BVA0400",
						"label": "DietSoda",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 1.0
					},
					"BVA0300": {
						"id": "BVA0300",
						"label": "ArtificiallySweetenedFruitDrinks",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "ArtificiallySweetenedBeverages",
				"value": 1.0
			},
			"meta-unsweetened-beverages": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"BVU0500": {
						"id": "BVU0500",
						"label": "Water",
						"include_subgroup": true,
						"suppress_increase": false,
						"suppress_decrease": true,
						"value": 0.0
					},
					"BVU0300": {
						"id": "BVU0300",
						"label": "UnsweetenedSoftDrinks",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVU0400": {
						"id": "BVU0400",
						"label": "UnsweetenedTea",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVU0100": {
						"id": "BVU0100",
						"label": "UnsweetenedCoffee",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.04933333333333333
					},
					"BVU0200": {
						"id": "BVU0200",
						"label": "UnsweetenedCoffeeSubstitutes",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "UnsweetenedBeverages",
				"value": 0.04933333333333333
			},
			"meta-alcoholic-beverages": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"BVE0100": {
						"id": "BVE0100",
						"label": "BeerandAles",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVE0400": {
						"id": "BVE0400",
						"label": "CordialandLiqueur",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVE0300": {
						"id": "BVE0300",
						"label": "DistilledLiquor",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"BVE0200": {
						"id": "BVE0200",
						"label": "Wine",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "AlcoholicBeverages",
				"value": 0.0
			},
			"meta-fried-foods": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MSF0100": {
						"id": "MSF0100",
						"label": "FriedShellfish",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MFF0200": {
						"id": "MFF0200",
						"label": "FriedFish",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FMC0100": {
						"id": "FMC0100",
						"label": "Vegetable-basedSavorySnack",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"VEG0800": {
						"id": "VEG0800",
						"label": "FrenchFries",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.5
					},
					"VEG0900": {
						"id": "VEG0900",
						"label": "FriedVegetables",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 1.264
					},
					"FRU0600": {
						"id": "FRU0600",
						"label": "FriedFruits",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MPF0200": {
						"id": "MPF0200",
						"label": "FriedChicken",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "FriedFoods",
				"value": 1.764
			},
			"meta-salty-snacks": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"GRS0900": {
						"id": "GRS0900",
						"label": "SnackChipsSomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0900": {
						"id": "GRR0900",
						"label": "SnackChips",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.6666666666666666
					},
					"GRW1200": {
						"id": "GRW1200",
						"label": "FlavoredPopcorn",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FMC0100": {
						"id": "FMC0100",
						"label": "VegetableBasedSavorySnack(PotatoChips)",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"FMC0200": {
						"id": "FMC0200",
						"label": "MeatBasedSavorySnack(PorkRinds)",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "SaltySnacks",
				"value": 0.6666666666666666
			},
			"meta-sweets-desserts": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MSC0600": {
						"id": "MSC0600",
						"label": "Misc",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0100": {
						"id": "DOT0100",
						"label": "FrozenDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0200": {
						"id": "DOT0200",
						"label": "FrozenNondairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0300": {
						"id": "DOT0300",
						"label": "PuddingandOtherDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"DOT0400": {
						"id": "DOT0400",
						"label": "ArtificiallySweetenedPuddingandOtherDairyDessert",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0800": {
						"id": "GRW0800",
						"label": "WholeGrainCookies,Pies,Pastries,Danish,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRS0800": {
						"id": "GRS0800",
						"label": "SomeWholeGrainCookies,Pies,Pastries,Danish,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0800": {
						"id": "GRR0800",
						"label": "Cookies,Pies,Pastries,Danish,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 1.812666666666667
					},
					"GRS1000": {
						"id": "GRS1000",
						"label": "SnackBarsSomeWholeGrain",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR1000": {
						"id": "GRR1000",
						"label": "SnackBars",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRR0300": {
						"id": "GRR0300",
						"label": "RefinedSnackBreads",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3246666666666667
					},
					"SWT0500": {
						"id": "SWT0500",
						"label": "Syrup,Honey,Jam",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3333333333333333
					},
					"SWT0400": {
						"id": "SWT0400",
						"label": "Sugar",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 2.609666666666667
					},
					"SWT0700": {
						"id": "SWT0700",
						"label": "Fudge,caramel,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"SWT0100": {
						"id": "SWT0100",
						"label": "ChocolateCandy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.1416666666666667
					},
					"SWT0200": {
						"id": "SWT0200",
						"label": "Candy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"SWT0300": {
						"id": "SWT0300",
						"label": "Frostingoricing",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Sweets&Desserts",
				"value": 5.222
			},
			"meta-healthier-snacks": {
				"include_subgroup": false,
				"suppress_increase": false,
				"suppress_decrease": true,
				"children": {
					"GRW1000": {
						"id": "GRW1000",
						"label": "WholeGrainSnackBars",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0900": {
						"id": "GRW0900",
						"label": "WholeGrainSnackChips",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW1100": {
						"id": "GRW1100",
						"label": "PlainPopcorn",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"GRW0300": {
						"id": "GRW0300",
						"label": "QuickandOtherBreads",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "HealthierSnacks",
				"value": 0.0
			},
			"meta-sweet-salty-condiments": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MSC0400": {
						"id": "MSC0400",
						"label": "Sweet/SaltySauces",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 3.208333333333333
					},
					"SWT0500": {
						"id": "SWT0500",
						"label": "Syrup,Honey,Jam",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3333333333333333
					},
					"SWT0400": {
						"id": "SWT0400",
						"label": "Sugar",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 2.609666666666667
					},
					"SWT0700": {
						"id": "SWT0700",
						"label": "Fudge,caramel,butterscotch,etc.",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"SWT0300": {
						"id": "SWT0300",
						"label": "Frostingoricing",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "Sweet/SaltyCondiments",
				"value": 6.151333333333334
			},
			"meta-fatty-condiments": {
				"include_subgroup": false,
				"suppress_increase": true,
				"suppress_decrease": false,
				"children": {
					"MSC0100": {
						"id": "MSC0100",
						"label": "Gravy",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MSC0200": {
						"id": "MSC0200",
						"label": "ReducedFatGravy",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.0
					},
					"MSC0300": {
						"id": "MSC0300",
						"label": "FattySauces",
						"include_subgroup": false,
						"suppress_increase": false,
						"suppress_decrease": false,
						"value": 0.3686666666666666
					},
					"FCF0100": {
						"id": "FCF0100",
						"label": "Cream",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.3333333333333333
					},
					"FDF0100": {
						"id": "FDF0100",
						"label": "CreamyDressings",
						"include_subgroup": true,
						"suppress_increase": true,
						"suppress_decrease": false,
						"value": 0.0
					}
				},
				"label": "FattyCondiments",
				"value": 0.702
			}
		},
		"active": true
	}]
}`}
            />
          </Grid>
          <Grid
            item
            xs={2}
          >
            <h3>Error Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
    "success": "false",
    "message": "Must be logged in"
}
  `}
            />
          </Grid>
        </Grid>
      </Typography>
    </AccordionDetails>
  );
};
const Wrapper = () => {
  return (
    <React.Suspense fallback={<AdminProgressBar />}>
      <DietsAll />
    </React.Suspense>
  );
};
export default Wrapper;
